import {USER_SET_LANGUAGE} from '~/frontend/src/constants';
import messageCatalog from '~/shared/src/utilities/messageCatalog';
import {
    StoreState,
    AppDispatch,
    Thunk
} from '~/frontend/src/store';
import setGlobalMask from '~/frontend/src/actions/ajax/setGlobalMask';
import clearGlobalMask from '~/frontend/src/actions/ajax/clearGlobalMask';
import saveCfgItem from '~/frontend/src/actions/user/saveCfgItem';
import loadCfgItem from '~/frontend/src/actions/user/loadCfgItem';
import cloneUser from '~/frontend/src/actions/user/cloneUser';


/**
 * @memberOf! Actions
 *
 * @param {string} language
 * @param {boolean} [temporary=false]
 *
 * @return {}
 */
const setLanguage = ( language : string, temporary : boolean = false ) : Thunk<Promise<void>> => async ( dispatch : AppDispatch, getState : () => StoreState ) => {
    dispatch( {
        type: USER_SET_LANGUAGE,
        language,
        temporary
    } );

    dispatch( setGlobalMask( 'switchLanguage' ) );

    const user = getState().session.user;

    if ( user ) {
        messageCatalog.language = language;
        user.language = language;

        if ( temporary ) {
            dispatch( cloneUser() );
        }
        else if ( await dispatch( saveCfgItem() ) ) {
            await dispatch( loadCfgItem() );
        }
    }

    dispatch( clearGlobalMask( 'switchLanguage' ) );
}

export type SetLanguage = typeof setLanguage;

export default setLanguage;
